var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<button type=\"button\" class=\"btn btn-default btn-sm btn-block dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" disabled>\n  "
    + container.escapeExpression(__default(require("../../helpers/t.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Select Feature",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":2,"column":2},"end":{"line":2,"column":26}}}))
    + "\n  <span class=\"caret\"></span>\n</button>\n<ul class=\"dropdown-menu\" style=\"max-height: 300px; overflow-y: scroll\"></ul>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// /src/views/filters/FeatureListView.hbs
// module id = 2076
// module chunks = 0